var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",class:{
	soft: _vm.soft
}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-inner"},[_c('img',{attrs:{"src":"/img/loader.gif"}})])
}]

export { render, staticRenderFns }